import React, {FC} from 'react';
import Chart from 'react-apexcharts';
import { ApexOptions } from 'apexcharts';
import {useTranslation} from "react-i18next";
import {Card, CardContent} from "framework7-react";
interface ChartBarComponentProps {
    currency?: string
}
export const ChartBarComponent: FC <ChartBarComponentProps> = ({currency}) => {
    const {t} = useTranslation();
    const options: ApexOptions = {
        chart: {
            type: 'bar',
            height: 250,
            toolbar: {
                show: false
            }
        },
        title: {
            text: t("dashboard.weeklySales"),
        },
        plotOptions: {
            bar: {
                horizontal: true,
            },
        },
        xaxis: {
            type: 'category',
        },
    };

    const series = [
        {
            name: 'Values',
            data: [
                { x: 'Jackpot', y: 22000 },
                { x: 'Quickbet', y: 18540 },
                { x: 'Smarbet', y: 23460 },
            ],
        },
    ];

    return(
        <Card>
            <CardContent>
                <Chart options={options} series={series} type="bar" height={250} />
            </CardContent>
        </Card>
    );
};
